module.exports = __webpack_public_path__ + "static/innerSlider-9db64de4983fdbf03c40b99744608475.jpg";